import * as React from "react";

const SvgSubmaster = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.275 3.18a.3.3 0 0 0-.55 0L8.1 11.51a.3.3 0 0 1-.542.016l-3.99-7.86C3.425 3.385 3 3.486 3 3.802v11.372a.3.3 0 0 0 .3.3h17.4a.3.3 0 0 0 .3-.3V3.802c0-.316-.425-.417-.567-.136l-3.99 7.86a.3.3 0 0 1-.543-.017zM20.7 21.014a.3.3 0 0 0 .3-.3v-2.17a.3.3 0 0 0-.3-.3H3.3a.3.3 0 0 0-.3.3v2.17a.3.3 0 0 0 .3.3z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSubmaster;
